import { ArticleImprint } from '@/components/ArticleImprint';
import { CmsPage } from '@/components/CmsInterfaces';
import ContentfulRichtext from '@/components/ContentfulRichtext';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { Layout } from '@/components/Layout';
import OfflineInfo from '@/components/OfflineInfo';
import Page from '@/components/Page';
import { newsConfig } from '@/config/news';
import classnames from '@/utilities/classnames';

interface PageContentculProps extends CmsPage {
  title: string;
  theme: string;
}

export default class PageContentful extends Page<PageContentculProps> {
  render() {
    const { theme, path, draw, publication } = this.props;
    const date = publication || draw;
    return (
      <>
        <Header parentPage={theme} />
        <main
          className={classnames('page', {
            [`page--${theme}`]: !!theme,
            'page-article': publication || draw,
          })}
        >
          <Layout
            theme={theme}
            path={path}
            date={date}
            backHref={date ? newsConfig.backHref : undefined}
            backLabel={date ? newsConfig.backLabel : undefined}
          >
            {ContentfulRichtext({
              json: this.props.richtext.json,
              links: this.props.richtext.links,
              date: draw,
            })}
            {date && <ArticleImprint category={theme} date={date} />}
          </Layout>
          <Footer />
          <OfflineInfo />
        </main>
      </>
    );
  }
}
